module.exports = __webpack_public_path__ + "static/media/scissors.fae64281.png";